module.exports = __webpack_public_path__ + "img/3-phone.ab35749f.jpg";